import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import moment from 'moment'
import { Button, Empty, Form, Icon, Input, message, Modal, Select, Spin, Switch, Table } from 'antd'
import { commissions } from '@services/api'
import {
    container,
    hRef,
    input_element,
    input_row,
    main_container,
    none,
    sumContent,
    tableClass,
    unsetMargin
} from '@pages/AgentCommissions/Reports/style.scss'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
class CurrentMonthReports extends Component<any> {
    refreshTimer: any = null

    columns = [
        {
            title: 'תאריך רכישה',
            key: 'paid_at',
            align: 'center',
            width: 130,
            render: (_, { date_paid_at }) => <div>{date_paid_at ? moment(date_paid_at).format('DD/MM/YY') : '-'}</div>
        },
        {
            title: 'שם לקוח',
            key: 'client_name',
            align: 'right',
            width: 340,
            render: (_, { client_name, client_id }) => this.userDiv(client_name, client_id, 'clients')
        },
        {
            title: 'שם סוכן',
            key: 'agent_name',
            align: 'right',
            width: 340,
            render: (_, { agent_name, agent_id }) => this.userDiv(agent_name, agent_id, 'agents')
        },
        {
            title: 'שם מנטור',
            key: 'mentor',
            align: 'right',
            width: 140,

            render: (_, { mentor }) => <div>{mentor}</div>
        },
        {
            title: 'עלות',
            key: 'price',
            align: 'center',
            width: 50,

            render: (_, { price }) => this.sumFormatter(price)
        },
        {
            title: 'שנתי',
            key: 'yearly',
            align: 'center',
            width: 120,

            render: (_, { yearly }) => this.sumFormatter(yearly)
        },
        {
            title: 'עמלה',
            key: 'commission',
            align: 'center',
            width: 120,

            render: (_, { commission }) => this.sumFormatter(commission)
        },
        {
            title: 'שם המוצר',
            key: 'heb_class',
            align: 'center',
            width: 180,
            render: (_, { heb_class }) => <div>{heb_class}</div>
        },
        {
            title: 'שם המנוי',
            key: 'sub_name',
            align: 'right',
            width: 400,

            render: (_, { subscription_name, sub_name }) => (
                <div style={{ direction: 'rtl' }}>{subscription_name || sub_name}</div>
            )
        },
        {
            title: 'הערה',
            key: 'comment',
            align: 'center',
            width: 90,
            render: (_, { comment }) => (
                <a href={'#'} className={`${hRef} ${comment ? '' : none}`} onClick={() => this.infoModal(comment)}>
                    {'להערה'}
                </a>
            )
        }
    ]

    constructor(props) {
        super(props)
        this.state = {
            client_id: null,
            agent_id: null,
            loading: false,
            loadingFile: false,
            list: [],
            total: 0,
            pageSize: 0,
            current: 1
        }
    }

    componentDidMount() {
        this.getCurrentMonthReports(1)
    }

    componentWillUnmount() {
        clearTimeout(this.refreshTimer)
    }

    infoModal = text => Modal.info({ title: text, okType: 'primary' })
    serverErrorMsg = (err: any) => Modal.error({ title: 'שגיאת שרת', content: err })

    userDiv = (name, id, role) => (
        <div>
            {name}
            {' - '}
            <a target={'_blank'} href={`/${role}/${id}`} className={hRef}>{`${id}`}</a>
        </div>
    )

    sumFormatter = num => {
        if (num === undefined || num === null) return ''
        num = parseFloat(num)
        const color = parseFloat(num) < 0 ? 'red' : 'green'
        let formatted = num.toFixed(2)
        if (formatted.includes('.') && formatted.endsWith('00')) formatted = parseFloat(formatted).toString()
        const str = formatted.toString()
        const parts = str.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        return (
            <div className={sumContent} style={{ color: color }}>
                {parts.join('.')}
            </div>
        )
    }

    getCurrentMonthReports = page => {
        this.setState({ loading: true })
        let { client_id, agent_id } = this.state
        commissions
            .commissionsCurrentMonth({ page, agent_id, client_id })
            .then(res => {
                const { data: list, total, perPage: pageSize, page: current } = res.data
                this.setState({ list, total, pageSize, current })
            })
            .catch(() => this.serverErrorMsg('שגיאת קבלת עמלות'))
            .finally(() => this.setState({ loading: false }))
    }

    onSearch = e => {
        e.preventDefault()
        this.getCurrentMonthReports(1)
    }

    onNumberInput = (event, key, _) => _.setState({ [key]: event.value.replace(/[^0-9]/g, '') })
    resetSearchData = () => {
        this.setState(
            {
                client_id: null,
                agent_id: null,
                loading: false
            },
            () => this.getCurrentMonthReports(1)
        )
    }
    onLoadExcel = () => {
        this.setState({ loadingFile: true })
        let { client_id, agent_id } = this.state
        commissions
            .enqueueClientsFile({ agent_id, client_id, isCurrentMonthReport: true })
            .then(() => {
                message.info('הקובץ בהכנה, יופיע ברשימת הקבצים בעוד מספר דקות')
                clearTimeout(this.refreshTimer)
                this.refreshTimer = setTimeout(() => this.props.getCommissionFile(), 60000)
            })
            .catch(() => this.serverErrorMsg('שגיאת הורדת קובץ'))
            .finally(() => this.setState({ loadingFile: false }))
    }

    render() {
        const { client_id, agent_id, loading, list, total, pageSize, current, loadingFile } = this.state
        const { getCurrentMonthReports, onSearch, onNumberInput, resetSearchData, onLoadExcel, columns } = this
        const downloadBtnType = loadingFile ? 'loading' : 'download'

        return (
            <div className={container}>
                <div className={main_container}>
                    <Form className={input_row} onSubmit={onSearch}>
                        <Input
                            placeholder={'מזהה לקוח'}
                            className={input_element}
                            value={client_id}
                            onInput={({ target }) => onNumberInput(target, 'client_id', this)}
                        />
                        <Input
                            placeholder={'מזהה סוכן'}
                            className={input_element}
                            value={agent_id}
                            onInput={({ target }) => onNumberInput(target, 'agent_id', this)}
                        />
                        <Button htmlType="submit">
                            <Icon type={'search'} />
                            {'חיפוש'}
                        </Button>
                        <Button onClick={resetSearchData} className={unsetMargin}>
                            {'איפוס'}
                            <Icon type={'sync'} />
                        </Button>
                    </Form>
                    <Button onClick={onLoadExcel} className={unsetMargin}>
                        <Icon type={downloadBtnType} />
                        {'הורדת קובץ'}
                    </Button>
                </div>
                {list.length ? (
                    <Table
                        className={`center-table ${tableClass}`}
                        rowKey="id"
                        columns={columns}
                        loading={loading}
                        dataSource={list}
                        rowClassName={record => record.commission_id + ''}
                        scroll={{ x: 800 }}
                        bordered={true}
                        pagination={{
                            total,
                            pageSize,
                            current,
                            hideOnSinglePage: true,
                            onChange: page => getCurrentMonthReports(page)
                        }}
                    />
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
            </div>
        )
    }
}

export default withRouter(CurrentMonthReports)
